export default __webpack_public_path__ + "static/img-ei-7-f1f1d17d06b289b4ec32989dd2b17e30.png";